import { render } from "./CreateVille.vue?vue&type=template&id=1086f698"
import script from "./CreateVille.vue?vue&type=script&lang=js"
export * from "./CreateVille.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__